// extracted by mini-css-extract-plugin
module.exports = {"link":"Link_link__23DLU","backLink":"Link_backLink__2Mj3O","nextLink":"Link_nextLink__3Qdah"};